//React Components and Hooks
import Gate from "components/Gate";
import { useCan } from "modules/settings/accessRoles";
import {
  Box,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider as MuiDivider,
  Skeleton,
  Tooltip,
  Typography as MuiTypography,
} from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { spacing } from "@mui/system";
//Material UI Components and Functions
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import StandardHeader from "../../components/global/StandardHeader";
// Custom application component imports:
import { LeftSidebar as NavFrame } from "layout-blueprints"; // The top navigation bar and side navigation panel
import { getBillingBatchById, resetBillingBatchSet } from "../../modules/billing/api/actions";
import BatchBillsTable from "../../modules/billing/components/BatchBillsTable";
import { logout } from "../../modules/user/api/actions";
import AnalyticsRange_DD from "./AnalyticsRange_DD"; // Dropdown to set the scope of the analytics data
import { useNavigate, useParams } from "react-router-dom";
const Divider = styled(MuiDivider)(spacing);
const Typography = styled(MuiTypography)(spacing);

const Batches = (props) => {
  const canRunBilling = useCan()("runBilling");
  const params = useParams();
  const navigate = useNavigate();

  const [resetDialogOpen, setResetDialogOpen] = useState(false);

  const getCompanyBillingDataAndRefreshPage = (isLoading = true) => {
    props.getBillingBatchById(params.id, isLoading);
  };

  const batchSet = props.billing.data.selectedBatch?.batchSet || {};
  const hasItems = (props.billing.data.selectedBatch?.items || []).length > 0;
  const isStuckAndResettable =
    batchSet.status === "In Progress" &&
    (batchSet.batchJob == null || batchSet.batchJob === "") &&
    !hasItems;

  const resetTooltip = isStuckAndResettable
    ? "Invalidate this stuck billing batch so it can be re-run"
    : "Only available when status is 'In Progress' with no batchJob and no generated bills";

  const openResetDialog = () => { if (canRunBilling) setResetDialogOpen(true); };
  const closeResetDialog = () => setResetDialogOpen(false);

  const confirmResetBatch = () => {
    if (batchSet.uuid) {
      props.resetBillingBatchSet(batchSet.uuid).finally(() => {
        closeResetDialog();
        navigate("/billingdashboard");
      });
    } else {
      closeResetDialog();
    }
  };

  const handleClose = (event, reason) => {};
  // On initial page load:
  // my apologies to anyone in the future who has to see this
  useEffect(() => {
    getCompanyBillingDataAndRefreshPage();
    const interval = setInterval(() => {
      var completeCount = "N/A";
      if (isError || props.billing.data.selectedBatch.items.length > 0) {
        const bills = props.billing.data.selectedBatch.items;
        emailCount = 0;
        printCount = 0;
        completeCount = 0;
        bills.map((bill) => {
          if (bill.email != null) {
            completeCount = completeCount + parseInt(bill.email);
          }
        });
      }
      if (completeCount < props.billing.data.selectedBatch.items.length) {
        getCompanyBillingDataAndRefreshPage(false);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  var isLoaded =
    props.billing.billingBatchDataIsLoading ||
    props.billing.data.selectedBatch.items.length > 0;
  const isError = props.billing.error != null && props.billing.error != "";

  if (props.billing.data.selectedBatch?.batchSetStatus?.jobs?.length > 0)
    var StatusMessage = `Processing Generated Billing Procedure: ${JSON.stringify(props.billing.data.selectedBatch.batchSetStatus.jobs[0].status)}`;
  else StatusMessage = `Processing Generated Billing Procedure`;
  if (props.billing.data.selectedBatch.items.length > 0) {
    StatusMessage = "Running Generated Billing Work Items";
  }

  var emailCount = "N/A";
  var printCount = "N/A";
  var completeCount = "N/A";
  var failedCount = "N/A";
  if (isError || props.billing.data.selectedBatch.items.length > 0) {
    const bills = props.billing.data.selectedBatch.items;
    emailCount = 0;
    printCount = 0;
    completeCount = 0;
    failedCount = 0;
    bills.map((bill) => {
      if (bill.email != null) {
        emailCount = emailCount + parseInt(bill.email);
      }
      if (bill.posted != null) {
        completeCount = completeCount + parseInt(bill.posted);
      }
      if (bill.printed != null && bill.print != "NO") {
        printCount = printCount + parseInt(bill.printed);
      }
      if (bill.accountBillId == 0) {
        failedCount++;
      }
    });
  }

  const totalBills =
    props.billing.data.selectedBatch.items.length > 0
      ? props.billing.data.selectedBatch.items.length.toString()
      : "N/A";

  document.title = "Batch Billing";
  // On Data Loaded:
  return (
    <NavFrame page={"Batches"}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignSelf: "stretch",
        }}
      >
        <Box sx={{ width: "100%", minWidth: 0 }}>
          <StandardHeader
            title="Property Billing Batch"
            rightSideToolBar={
              <AnalyticsRange_DD
                handleRefreshClick={getCompanyBillingDataAndRefreshPage}
              />
            }
          />
        </Box>
        <Divider className="mb-3 mt-3" sx={{ width: "100%" }} />
        {props.billing.error != "" && props.billing.error != null && (
          <Snackbar open={true} autoHideDuration={6000} onClose={handleClose}>
            <MuiAlert elevation={6} severity="error" onClose={handleClose}>
              <Typography>Error - {props.billing.error}</Typography>
            </MuiAlert>
          </Snackbar>
        )}
        <Box
          sx={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            gap: 3,
            boxSizing: "border-box",
          }}
        >
          <Card
            elevation={2}
            sx={{
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              borderRadius: 1,
              bgcolor: "background.paper",
              boxShadow: 2,
              boxSizing: "border-box",
            }}
          >
            <CardContent sx={{ py: 2, px: 2.5, "&:last-child": { pb: 2 } }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  flexWrap: "wrap",
                }}
              >
                <Typography variant="body1" color="text.primary" sx={{ textAlign: "left" }}>
                  {StatusMessage}
                </Typography>
                <Tooltip title={resetTooltip}>
                  <span>
                    <Gate capability="runBilling">
                    <Button
                      variant="outlined"
                      color="warning"
                      size="small"
                      disabled={!isStuckAndResettable}
                      onClick={openResetDialog}
                    >
                      Reset Batch Billing
                    </Button>
                    </Gate>
                  </span>
                </Tooltip>
              </Box>
            </CardContent>
          </Card>
          {props.billing.data.selectedBatch.items.length > 0 && (
            <>
              <Box
                sx={{
                  display: "grid",
                  width: "100%",
                  maxWidth: "100%",
                  minWidth: 0,
                  boxSizing: "border-box",
                  gap: 3,
                  gridTemplateColumns: {
                    xs: "minmax(0, 1fr)",
                    sm: "repeat(2, minmax(0, 1fr))",
                    md: "repeat(4, minmax(0, 1fr))",
                  },
                }}
              >
                {[
                  { label: "Total Bills", value: totalBills },
                  { label: "Printed", value: printCount.toString() },
                  { label: "Emailed", value: emailCount.toString() },
                  { label: "Failed", value: failedCount.toString() },
                ].map((stat) => (
                  <Card
                    key={stat.label}
                    elevation={2}
                    sx={{
                      height: "100%",
                      minWidth: 0,
                      width: "100%",
                      borderRadius: 1,
                      bgcolor: "background.paper",
                      boxShadow: 2,
                      boxSizing: "border-box",
                    }}
                  >
                    <CardContent sx={{ py: 2.5, px: 2, "&:last-child": { pb: 2.5 } }}>
                      <Box sx={{ textAlign: "left" }}>
                        {isLoaded ? (
                          <>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{
                                display: "block",
                                textTransform: "none",
                                letterSpacing: 0,
                                mb: 1,
                                fontSize: "0.8125rem",
                              }}
                            >
                              {stat.label}
                            </Typography>
                            <Typography
                              variant="h4"
                              component="p"
                              sx={{ fontWeight: 700, lineHeight: 1.2, color: "text.primary" }}
                            >
                              {stat.value}
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Skeleton variant="text" width="55%" height={20} sx={{ mb: 1 }} />
                            <Skeleton variant="text" width="45%" height={48} />
                          </>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
              <Box sx={{ width: "100%", maxWidth: "100%", minWidth: 0 }}>
                <BatchBillsTable />
              </Box>
            </>
          )}
        </Box>
      </Box>
      <Dialog
        open={resetDialogOpen}
        onClose={closeResetDialog}
        aria-labelledby="reset-batch-billing-dialog-title"
      >
        <DialogTitle id="reset-batch-billing-dialog-title">Please Confirm</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1 }}>
            This will invalidate the current Billing Batch so a new run can be started.
          </Typography>
          <Typography variant="body2" color="text.secondary">
            The batch set will be marked as Cancelled and hidden from the list. This action
            cannot be undone.
          </Typography>
          <Typography variant="caption" sx={{ display: "block", mt: 2, color: "#666" }}>
            Batch Set UUID: {batchSet.uuid || "—"}
          </Typography>
          <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}>
            <Button onClick={closeResetDialog} variant="outlined">
              Cancel
            </Button>
            <Button onClick={confirmResetBatch} variant="contained" color="warning">
              Reset Batch Billing
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </NavFrame>
  );
};

// Component Properties
Batches.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  getBillingBatchById: PropTypes.func.isRequired,
  resetBillingBatchSet: PropTypes.func.isRequired,
};

// Component State
function BatchesPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
  };
}
export default connect(BatchesPageState, {
  logout,
  getBillingBatchById,
  resetBillingBatchSet,
})(Batches);
